import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  drivers: {},
  transactions: {},
  loading: false,
})

const { Types, Creators } = createActions({
  getTransactions: ['startedAt', 'endedAt'],
  setTransactions: ['drivers', 'transactions'],
})

export const getTransactionsReducer = state => state.set('loading', true)

export const setTransactionsReducer = (state, { drivers, transactions }) =>
  state
      .set('drivers', drivers)
      .set('transactions', transactions)
      .set('loading', false)

export const driverTransactionReducer = createReducer(INITIAL_STATE, {
  [Types.GET_TRANSACTIONS]: getTransactionsReducer,
  [Types.SET_TRANSACTIONS]: setTransactionsReducer,
})

export const DriverTransactionTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/driverTransactionReducer.js